<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres
        titulo="Autores(as) de Emendas"
        :botoes="botoesHeader"
        breakpoint="xl"
      />
    </template>
    <b-card-body>
      <CardFiltrosBusca>
        <b-form @submit.prevent="filtrarAutores" @reset.prevent="limparFiltros">
          <b-row>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Nome do autor(a)"
                rules=""
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-nome"
                  v-model="filtros.filtroNome"
                  :state="defaultState.state"
                  placeholder="Digite o nome"
                  autofocus
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6">
              <default-form-validation-provider
                label="Tipo do autor(a)"
                rules=""
                v-slot="defaultState"
              >
                <b-overlay :show="loadingTipos">
                  <b-form-select
                    id="select-tipo"
                    :state="defaultState.state"
                    :options="listaTipos"
                    v-model="filtros.filtroTipo"
                  />
                </b-overlay>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6" xl="3" offset-xl="3">
              <b-button type="reset" variant="outline-secondary">
                <font-awesome-icon icon="redo" class="mr-3" />
                Limpar
              </b-button>
            </b-col>
            <b-col cols="6" xl="3">
              <b-button type="submit" :disabled="tableBusy || loadingTipos">
                <font-awesome-icon icon="search" class="mr-3" />
                Filtrar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </CardFiltrosBusca>
      <b-table
        id="autoresTable"
        :fields="fields"
        :items="items"
        :busy="tableBusy"
        :current-page="currentPage"
        :filter="filter"
        hover
        no-border-collapse
        sort-by=""
        :sort-desc="true"
        striped
        stacked="xl"
        show-empty
        :per-page="pageSize"
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle" />
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <b-dropdown class="d-md-none" right no-caret>
            <template #button-content>
              <font-awesome-icon icon="bars" />
            </template>
            <b-dropdown-item @click="editarAutor(row.item)">
              <font-awesome-icon icon="edit" />
              <span>Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="alertaRemove(row.item)">
              <font-awesome-icon icon="trash" />
              <span>Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
          <div
            class="actions-icons lgvert d-none d-md-flex justify-content-center"
          >
            <b-link class="text-dark" @click="editarAutor(row.item)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </b-link>
            <b-link class="text-dark" @click="alertaRemove(row.item)">
              <font-awesome-icon icon="trash" />
              <div style="font-size: 12px">Excluir</div>
            </b-link>
          </div>
        </template>
      </b-table>
      <table-pagination
        v-if="totalRows"
        :total-rows="totalRows"
        :per-page="pageSize"
        @pageChange="pageChange"
      />
    </b-card-body>

    <ModalSalvarAutor
      v-if="modalAbertoSalvar"
      :title="title"
      :autor="autor"
      :listaTipos="listaTipos"
      @close="closeModalSalvar"
      @reload="filtrarAutores"
    />
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { BotaoSagres } from "@/types/botao-sagres";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { fieldsAutores } from "@/types/administracao/autor/fields-autores";
import { SelectValue } from "@/types/select-value";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import autorService from "@/services/administracao/autorService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { Autor } from "@/types/administracao/autor/autor";
import ModalSalvarAutor from "@/components/administracao/autor/ModalSalvarAutor.vue";

const CompProps = Vue.extend({
  name: "ConsultarAutoresEmendas",
  components: {
    HeaderSagres,
    DefaultFormValidationProvider,
    CardFiltrosBusca,
    TablePagination,
    ModalSalvarAutor,
  },
});

@Component
class ConsultarAutoresEmendas extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "plus",
      texto: "Criar Autor(a)",
      acao: this.openModalHomologar,
    },
  ];

  fields: TableField[] = fieldsAutores;
  items: Autor[] = [];

  filter = "";
  currentPage = 1;
  pageSize = 10;
  totalRows = 0;
  tableBusy = false;
  loadingTipos = true;

  filtros = {
    filtroNome: null,
    filtroTipo: undefined,
  };

  listaTipos: SelectValue[] = [];

  modalAbertoSalvar = false;
  autor: Autor | null = null;
  title = "";

  async created() {
    this.getListaTipos();
    this.filtrarAutores();
  }

  async pageChange(value: number) {
    this.currentPage = value;
    await this.filtrarAutores();
  }

  async getListaTipos() {
    try {
      this.loadingTipos = true;
      const tipos = await autorService.getTipos();
      this.listaTipos = tipos.map((a: { Id: number; Descricao: string }) => {
        return { value: a.Id, text: a.Descricao };
      });
      this.listaTipos.unshift({ value: null, text: "Selecione o tipo" });
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingTipos = false;
    }
  }

  editarAutor(autor: Autor) {
    if (autor) {
      try {
        this.openModalHomologar(autor);
      } catch (e: unknown) {
        console.error(e);
        this.tratarError(e);
      }
    } else this.$toast.error(`Erro ao obter dados do(a) autor(a)`);
  }

  alertaRemove(autor: Autor) {
    this.$bvModal
      .msgBoxConfirm(`Deseja excluir o(a) autor(a) ${autor.NmAutor}?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        okVariant: "secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        title: "Exclusão de Autor(a)",
      })
      .then(async (value) => {
        if (value) await this.excluirAutor(autor);
      })
      .catch((err) => {
        console.error(`Erro ao operar o dialog de alerta de excluir`, err);
      });
  }

  async excluirAutor(autor: Autor) {
    try {
      await autorService.removeAutor(autor.IdAutor);
      return this.$toast.success(
        `Autor(a) ${autor.NmAutor} excluído(a) com sucesso!`
      );
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      await this.filtrarAutores();
    }
  }

  async filtrarAutores() {
    try {
      this.tableBusy = true;
      const response: Autor[] = await autorService.getAutores(
        this.currentPage,
        this.pageSize,
        this.filtros.filtroNome ?? "",
        this.filtros.filtroTipo ?? undefined
      );
      if (!response)
        return this.$toast.error("Erro ao obter a lista de autores(as)");
      this.items = response;
      this.totalRows = response.length;
    } catch (error: unknown) {
      this.items = [];
      this.totalRows = 0;
      this.tratarError(error);
    } finally {
      this.tableBusy = false;
    }
  }

  openModalHomologar(autor?: Autor): void {
    try {
      this.tableBusy = true;
      this.autor = autor ? new Autor(autor) : new Autor();
      this.title = this.autor?.IdAutor
        ? `Editar ${this.autor.NmAutor}`
        : `Criar autor(a)`;
      this.modalAbertoSalvar = true;
    } catch (error) {
      console.error(error);
    } finally {
      this.tableBusy = false;
    }
  }

  closeModalSalvar(): void {
    this.modalAbertoSalvar = false;
  }

  limparFiltros() {
    return (this.filtros = {
      filtroNome: null,
      filtroTipo: undefined,
    });
  }
}

export default ConsultarAutoresEmendas;
</script>